import { render, staticRenderFns } from "./ShopOwnerHistory.vue?vue&type=template&id=73749ba3&scoped=true&"
import script from "./ShopOwnerHistory.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerHistory.vue?vue&type=style&index=0&id=73749ba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73749ba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VRow,VSelect})
